import * as angular from 'angular';
import 'angular-ui-router';
import 'angular-modal-service';
import 'angular-cookies';
import 'angular-base64';
import './DetailApplication.scss';
import { DetailApplicationController, UnauthorizedAccessEvent, } from './DetailApplicationController';
import { SubheaderDetailController } from '../../navbar/subheader/SubheaderDetailController';
import DetailApplicationView from './DetailApplicationView.html';
import SubheaderDetailView from '../../navbar/subheader/SubheaderDetailView.html';
import BreadcrumbSubheaderDetailView from '../../navbar/subheader/breadcrumbPipeline/breadcrumbApplicationView.html';
import { SidebarConfigsService } from './SidebarConfigsService';
import ai from './ai';
import channels from './channels';
import users from './users';
import contents from './contents';
import analytics from './analytics';
import { configurations } from './configurations';
import { growth } from './growth';
import { aiAgents } from './aiAgents';
import { builderObservability } from './builderObservability';
import smartSales from './smartSales';
import templates from './portal-submodule-builder/templates';
import templatesPipeline from './portal-submodule-builder-pipeline/templates';
import team from './team';
import integrations from './integrations';
import attendance from './attendance';
import { home } from './home';
import { FeatureToggleClientService } from 'feature-toggle-client';
import { ldclientSdkKey, ldProxyBaseUrl, ldProxyEventsUrl, ldProxyClientStream, ldStreamReconnectDelay, defaultClusterName, } from 'app.constants';
import { logoutStateName } from 'modules/login';
import { externalPlugin } from './externalPlugin';
import { getCallerShortNameApplicationInParam, getShortNameOfSubflowInParam, stateParamHasSubflow, } from './portal-submodule-builder/templates/builder/subflow/StateParamInterpreter';
import { ActiveMessageDeskSharedService } from 'modules/shared/ActiveMessageDesk/ActiveMessageDeskSharedService';
import { AnswersService } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/AnswersService';
import { ConfigurationFeatures } from './configurations/ConfigurationFeatures';
import { ChannelsFeatures } from './channels/ChannelsFeatures';
import { BreadcrumbApplicationController } from 'modules/navbar/subheader/breadcrumbPipeline/breadcrumbApplicationController';
import { StudioTrialController } from 'modules/navbar/subheader/studioTrial/StudioTrial.controller';
export default angular
    .module('application.detail', [
    'ui.router',
    'angularModalService',
    'ngCookies',
    'base64',
    ai,
    channels,
    users,
    contents,
    analytics,
    configurations,
    growth,
    aiAgents,
    builderObservability,
    smartSales,
    templates,
    templatesPipeline,
    team,
    integrations,
    attendance,
    home,
    externalPlugin,
])
    .service('SidebarConfigsService', SidebarConfigsService)
    .service('AnswersService', AnswersService)
    .service('ActiveMessageDeskSharedService', ActiveMessageDeskSharedService)
    .controller('DetailApplicationController', DetailApplicationController)
    .controller('SubheaderDetailController', SubheaderDetailController)
    .component('studioTrial', StudioTrialController)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('auth.application.detail', {
            url: '/application/detail/:shortName',
            abstract: true,
            redirectTo: ($stateParams) => stateParamHasSubflow($stateParams)
                ? 'auth.application.detail.builder'
                : 'auth.application.detail.home',
            resolve: {
                application: fetchApplication,
            },
            views: {
                'subheader@auth': {
                    template: SubheaderDetailView,
                    controller: SubheaderDetailController,
                    controllerAs: '$ctrl',
                },
                'breadcrumb@auth': {
                    template: BreadcrumbSubheaderDetailView,
                    controller: BreadcrumbApplicationController,
                    controllerAs: '$ctrl',
                },
                '@auth.application': {
                    template: DetailApplicationView,
                    controller: DetailApplicationController,
                    controllerAs: '$ctrl',
                },
            },
        });
    }])
    .run(['$rootScope', '$state', 'ngToast', '$translate', 'BLIP_ACCOUNT_TOGGLE_DEFAULT_VALUE',
    function ($rootScope, $state, ngToast, $translate, BLIP_ACCOUNT_TOGGLE_DEFAULT_VALUE) {
        $rootScope.$on(UnauthorizedAccessEvent, async (e, { application }) => {
            if (BLIP_ACCOUNT_TOGGLE_DEFAULT_VALUE) {
                $state.go(logoutStateName);
            }
            if ($state.current.name.indexOf('auth.application.detail.ai') !== -1) {
                const nextPermission = application.applicationUserPermissionModel.find(perm => (perm.permissionClaim === 103 || perm.permissionClaim === 104 || perm.permissionClaim === 117)
                    && perm.permissionAction > 0) || {};
                let route = '';
                if (nextPermission.permissionClaim === 103) {
                    route = 'auth.application.detail.ai.intentions';
                }
                else if (nextPermission.permissionClaim === 104) {
                    route = 'auth.application.detail.ai.enhancement';
                }
                else if (nextPermission.permissionClaim === 117) {
                    route = 'auth.application.detail.ai.answers';
                }
                if (route) {
                    $state.go(route, {
                        shortName: application.shortName,
                    });
                    return;
                }
            }
            else if ($state.current.name ===
                'auth.application.detail.configurations.basic') {
                const nextPermission = application.applicationUserPermissionModel.find(perm => perm.permissionClaim === 110 &&
                    perm.permissionAction > 0);
                if (nextPermission) {
                    $state.go('auth.application.detail.configurations.apikey', {
                        shortName: application.shortName,
                    });
                    return;
                }
            }
            const errorMsg67 = await $translate('utils.errorMsg.67');
            ngToast.danger(errorMsg67);
            $state.go('auth.application.detail.home', {
                shortName: application.shortName,
            });
        });
    },
]).name;
const fetchApplication = [
    'ApplicationService2',
    'AdminService',
    'AuthenticationService',
    'BlipService',
    'ChannelsService',
    'MessagingHubService',
    'HostingService',
    'TenantService',
    '$rootScope',
    '$stateParams',
    'ngToast',
    '$translate',
    'LoadingService',
    'CacheService',
    'CurrentApplicationService',
    '$state',
    '$location',
    'isUserInitialized',
    'AnswersService',
    async (ApplicationService2, AdminService, AuthenticationService, BlipService, ChannelsService, MessagingHubService, HostingService, TenantService, $rootScope, $stateParams, ngToast, $translate, LoadingService, CacheService, CurrentApplicationService, $state, $location, isUserInitialized, // This dependency injection is needed to wait for user initialization
    AnswersService) => {
        if (stateParamHasSubflow($stateParams)) {
            return fetchSubflowApplication($stateParams, $rootScope, CurrentApplicationService, LoadingService);
        }
        LoadingService.startLoading(false);
        try {
            // TODO: Move this to outside of the 'application' route.
            // Check if there's an active connection with blip.ai Iris service.
            if (!(await BlipService.isConnected())) {
                await BlipService.connect(encodeURIComponent(AuthenticationService.email), AuthenticationService.token);
            }
            const application = await ApplicationService2.getApplication($stateParams.shortName);
            await MessagingHubService.resetClient(application);
            const useConfigurationApplicationGet = await ChannelsFeatures.isConfigurationsDomainOnChannelsOperationsGetEnabled();
            const useGatewayConfigurationsEndpoint = await ChannelsFeatures.isGatewayConfigurationsFromNewEndpointEnabled();
            application.aiAnswersEnabled = await AnswersService.isEnabled();
            application.channels = await ChannelsService.getAllChannels(useConfigurationApplicationGet, useGatewayConfigurationsEndpoint);
            application.plan = await TenantService.getTenantPlan(application.tenantId);
            const clusterName = application.tenantId && (await TenantService.getTenantClusterName(application.shortName));
            application.cluster = (clusterName && clusterName.toUpperCase()) || defaultClusterName.toUpperCase();
            const currentTenant = window.location.hostname.split('.')[0];
            if (application.tenantId && application.tenantId.toLowerCase() !== currentTenant.toLowerCase()) { // Redirect if bot is being accessed via another tenant
                redirectToCorrectBotUrl(application.tenantId);
                return;
            }
            // Do not attempt to retrieve the application.json template if it is SDK (undefined) or webhook
            let applicationJson;
            if (!application.template ||
                application.template === 'sdk' ||
                application.template === 'undefined' ||
                application.template === 'webhook') {
                applicationJson = application;
                application.isTemplate = false;
            }
            else {
                applicationJson = await HostingService.getApplicationJson(application, true);
                application.isTemplate = true;
            }
            const isSanitizeAccessKeyInBot = await ConfigurationFeatures.isSanitizeAccessKeyInBot();
            if (isSanitizeAccessKeyInBot) {
                delete applicationJson.accessKey;
            }
            application.applicationJson = applicationJson;
            $rootScope.application = application;
            const applicationHasCluster = await hasCluster(application, AdminService);
            // Initialize application client
            FeatureToggleClientService.getInstance().initializeApplication({
                ...application,
                hasCluster: applicationHasCluster,
            }, ldclientSdkKey, {
                baseUrl: ldProxyBaseUrl,
                eventsUrl: ldProxyEventsUrl,
                streamUrl: ldProxyClientStream,
                streamReconnectDelay: ldStreamReconnectDelay,
            });
            CacheService.add(application.shortName, application, 60000);
            return application;
        }
        catch (err) {
            const errorMsg = await $translate('applicationError.generic');
            let errorJson;
            try {
                errorJson = JSON.parse(err);
            }
            catch (e) {
                ngToast.danger(errorMsg);
                $state.go('auth.application.list');
                console.error(e);
                return;
            }
            const { code } = (errorJson && errorJson.reason) || { code: 0 };
            let forbidden = false;
            switch (code) {
                case 66:
                    forbidden = true;
                    await retryOpenforbiddenUserAlert();
                    break;
                default:
                    ngToast.danger(errorMsg);
                    break;
            }
            $state.go('auth.application.list', {
                forbidden,
                shortName: $stateParams.shortName,
            });
        }
        finally {
            LoadingService.stopLoading();
        }
    },
];
const fetchSubflowApplication = async ($stateParams, $rootScope, CurrentApplicationService, LoadingService) => {
    'ngInject';
    LoadingService.startLoading(false);
    try {
        const shortName = getShortNameOfSubflowInParam($stateParams);
        const callerShortName = getCallerShortNameApplicationInParam($stateParams);
        $rootScope.application = await CurrentApplicationService.fetchSubflowApplication(shortName, callerShortName);
    }
    finally {
        LoadingService.stopLoading();
    }
    return $rootScope.application;
};
// Verify if application has CLuster
const hasCluster = async (application, AdminService) => {
    const isConfigurationsApplicationGetEnabled = await ConfigurationFeatures.isConfigurationDomainOnAdvancedConfigurationPropertiesGetEnabled();
    const adminConfiguration = await AdminService.get(application, isConfigurationsApplicationGetEnabled);
    return adminConfiguration && adminConfiguration.Cluster ? true : false;
};
const retryOpenforbiddenUserAlert = async () => {
    const bdsAlert = document.querySelector('bds-alert[id=forbiddenUserAlertList]');
    if (bdsAlert) {
        await bdsAlert.toggle();
    }
};
const redirectToCorrectBotUrl = async (botTenant) => {
    const currentUrl = window.location;
    const protocol = currentUrl.protocol;
    const hostname = currentUrl.hostname;
    const port = currentUrl.port ? `:${currentUrl.port}` : '';
    const pathname = currentUrl.pathname;
    const search = currentUrl.search;
    const hostnameParts = hostname.split('.');
    hostnameParts[0] = botTenant;
    const newHostname = hostnameParts.join('.');
    const newUrl = `${protocol}//${newHostname}${port}${pathname}${search}`;
    window.location.href = newUrl;
};
